// extracted by mini-css-extract-plugin
export default {"container":"rN-z","topReviewHeading":"sN-z","criticalReview":"tN-z","favorableReview":"uN-z","vsSeparator":"vN-z"};